require("./m_ynet_newsFlashSpecialMobileComponent.less")
import * as axios from "axios";
import { addAxiosDateTransformerSettings } from "../../../../../../../utils/network/axiosDateTransformer";
import { NewsFlashSpecialMobileSlotList } from "./newsFlashSpecialMobileSlotList";
import { categoryObj } from "../../../../newYnetTvVerticalDynamic/components/newYnetTvVerticalDynamicComponenta";
import { ItemJsonVer2, ArticleDataJsonVer2 } from "../../../../../../jsonSerializer/widgetJsonInterfacesVer2";
import { mapItemJsonToArticleExtraData, mapArticleExtraDataToOverlayItems } from "../utils/newsFlashUtils";

interface NewsFlashSpecialMobileComponentProps {
    isLTR: boolean
    domain: string
    componentaId?: string
    languageCode: string
    category: categoryObj
    tickerCategoryId: string
    tickerBottomLink: string
    roofOngoingEvent: boolean
    tickerBottomTitle: string
    tabBackgroundColor: string
    numberOfVisibleItems: number
    highlightingDuration: number
    verticalBackgroundImage: string
}

interface NewsFlashSpecialMobileComponentState {
    shouldDisplayTicker: boolean
    pageNumber: number
    tickerArticles: ItemJsonVer2[]
    isFirstInterval: boolean
    shouldDisplayLoader: boolean
    isFetchingPaused: boolean
    overlayedItems: ItemJsonVer2[]
}

export class NewsFlashSpecialMobileComponent extends React.Component<NewsFlashSpecialMobileComponentProps, NewsFlashSpecialMobileComponentState> {

    public static siteScriptName = "NewsFlashSpecialMobileComponent"
    private tickerIntervalId: any;
    private prevItemKeys: string[] = [];

    constructor(props) {
        super(props)
        this.state = {
            pageNumber: 0,
            tickerArticles: [],
            isFirstInterval: true,
            isFetchingPaused: false,
            shouldDisplayTicker: true,
            shouldDisplayLoader: false,
            overlayedItems: []
        }
    }

    componentDidMount() {
        this.getTickerArticles()
         this.getOverlayItemsFromArticles();
        this.startFetchingInterval();
    }

    componentWillUnmount() {
        if (this.tickerIntervalId) {
            clearInterval(this.tickerIntervalId);
        }
    }

    private startFetchingInterval = () => {
        this.tickerIntervalId = setInterval(() => {
            if (!this.state.isFetchingPaused) {
                this.setState({ isFirstInterval: false })
                this.getTickerArticles()
            }
        }, 60000);
    }

    private pauseFetching = () => {
        this.setState({ isFetchingPaused: true });
    }

    private resumeFetching = () => {
        this.setState({ isFetchingPaused: false });
    }

    private handleOverlayOpen = () => {
        this.pauseFetching();
        this.getOverlayItemsFromArticles();
    }

    private handleOverlayClose = () => {
        this.resumeFetching();
    }

    private getTickerArticles() {
        const axiosInstance = axios.create(addAxiosDateTransformerSettings());
        axiosInstance.get(`/iphone/json/api/auto_ticker/${this.props.componentaId}`)
            .then((res: any) => {
                const newArticles = res.data.data.tickerAuto.data;
                const converted = newArticles.map(article => article);

                const newKeys = converted.map(a => `${a.articleId}_${new Date(a.dateUpdatedOnSite).getTime()}`);

                const hasNewArticle = this.prevItemKeys.length > 0 && newKeys.some(key => !this.prevItemKeys.includes(key));

                if (hasNewArticle) {
                    this.setState({ shouldDisplayLoader: true });
                    setTimeout(() => {
                        this.setState({ shouldDisplayLoader: false });
                    }, 3000);
                }

                this.prevItemKeys = newKeys;
                this.setState({ tickerArticles: converted });
            })
            .catch(err => console.error("error geting ticker data:", err))
    }

    private getOverlayItemsFromArticles() {
        const axiosInstance = axios.create(addAxiosDateTransformerSettings());
        axiosInstance.get('/iphone/json/mobile/v2/page/184')
            .then((res: any) => {
                const articles: ItemJsonVer2[] = res.data.components.find((component) => component.name === "flashesHeadlines").items;

                const newKeys = articles.map(a => {
                    const link = a.linkData.link as Partial<ArticleDataJsonVer2>;
                    return `${link.id}_${new Date(link.pubDate).getTime()}`;
                });
                const hasNewArticle = this.prevItemKeys.length > 0 && newKeys.some(key => !this.prevItemKeys.includes(key));

                if (hasNewArticle) {
                    this.setState({ shouldDisplayLoader: true });
                    setTimeout(() => {
                        this.setState({ shouldDisplayLoader: false });
                    }, 3000);
                }

                this.prevItemKeys = newKeys;
                this.setState({ overlayedItems: articles });
            })
            .catch(err => console.error("error geting ticker data:", err))
    }

    public render() {

        const { tickerBottomLink, languageCode, tickerBottomTitle, highlightingDuration, roofOngoingEvent, isLTR, domain, category, tabBackgroundColor, verticalBackgroundImage, numberOfVisibleItems } = this.props;
        const { tickerArticles, shouldDisplayTicker, isFirstInterval, shouldDisplayLoader } = this.state;
        const highlightDur = highlightingDuration != null ? highlightingDuration : 0;
        const articleExtraDataItems: any[] = tickerArticles.map(article => article);
        const overlayedItems = this.state.overlayedItems.map(article => mapItemJsonToArticleExtraData(article));
        const overlayItems = mapArticleExtraDataToOverlayItems(overlayedItems, verticalBackgroundImage);
        let flashTitle = "מבזקים";
        if (languageCode && languageCode.includes("en")) {
            flashTitle = "Breaking News"
        }
        else if (languageCode && languageCode.includes("ru")) {
            flashTitle = "последние новости"
        }

        return (
            <div className="news-flash-special-mobile-component">
                <div className="news-flash-special-mobile-tab" style={{ backgroundColor: tabBackgroundColor }}>
                    <div className="tab-title-container">
                        <div className="tab-icon"></div>

                        <div className="tab-title">{flashTitle}</div>
                    </div>

                    <a className="tab-btn" href={tickerBottomLink} id="ticker-link-btn">
                        <div className="btn-title">{tickerBottomTitle}</div>

                        <div className="btn-arrow"></div>
                    </a>
                </div>

                <NewsFlashSpecialMobileSlotList
                    isLTR={isLTR}
                    domain={domain}
                    category={category}
                    languageCode={languageCode}
                    isFirstInterval={isFirstInterval}
                    onOverlayOpen={this.handleOverlayOpen}
                    roofOngoingEvent={roofOngoingEvent}
                    highlightingDuration={highlightDur}
                    tickerBottomLink={tickerBottomLink}
                    onOverlayClose={this.handleOverlayClose}
                    tickerBottomTitle={tickerBottomTitle}
                    shouldDisplayTicker={shouldDisplayTicker}
                    shouldDisplayLoader={shouldDisplayLoader}
                    overlayItems={overlayItems}
                    tickerArticles={articleExtraDataItems.slice(0, numberOfVisibleItems)}
                />
            </div >
        )
    }
}